import React from 'react'
import { useUserPaymentsContextValue } from '../../context/UserPaymentsProvider'
import { CancelBonusModal } from './CancelBonusModal'

export const CancelBonusFlow = () => {
  const {
    state: { cancelBonus },
  } = useUserPaymentsContextValue()

  if (!cancelBonus) {
    return null
  }

  return <CancelBonusModal />
}
